<div class="spinner-container" *ngIf="isDelayedRunning">
  <div class="spinner {{style}}">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>
</div>
